$( "#location_toggle" ).click(function() {
  $( "#locationTable" ).show();
  $("#selected_location").hide();
});

$( "#ansi_toggle" ).click(function() {
  $( "#automotiveOptions1" ).toggle( "slow" );
});

$( "#results_toggle" ).click(function() {
  $( "#results" ).toggle( "slow" );
});

var url = "//automotive.bulbamerica.com/automotive/getData_New.php";

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function setData(data, select_id){
     var toAppend = '';
     var select = '';
     if(select_id == "make")
         toAppend += '<option value="">Make</option>';
     else if(select_id == "year")
         toAppend += '<option value="">Year</option>';
     else if(select_id == "model")
         toAppend += '<option value="">Model</option>';
     else if(select_id == "main_location")
         toAppend += '<option value="">Main Location</option>';
     else if(select_id == "location")
         toAppend += '<option value="">Location</option>';
     else if(select_id == "product"){
         toAppend += "<div class='collection-wrap clearfix'>" +
                        "<div class='collection-main'>" +
                           "<ul class='block-grid collection-th columns5'>";
     }
    $.each(data,function(i,o){
        if(i != 0){
            if(select_id != "product"){
                if(getParameterByName(select_id) == o.value){
                    select = 'selected= "selected"';
                }else{
                    select = '';
                    if(select_id == "type")
                    {
                        if(data.length == 2){
                            select = 'selected= "selected"';
                        }
                    }
                }
                toAppend += '<option value ="' + o.id + '"' + select +'>'+o.value+'</option>';
            }
            else
            {
              var onclick = "productClick('" + o.name + "', '" + o.sku + "', 'Automotive', '', '"+ o.price +"','Automotive')";
                toAppend += 
                "<li>" +
                    "<a class='prod-th show-quick' href='" + o.link + "' title='" + o.name + "' style='height: 353px;' onclick = \"" + onclick +"\">" +
                        "<span class='thumbnail'>" +
                            "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                            "<span class='quick-view' data-prdid='#prod-" + o.id + "' style='display: none;'>QUICK VIEW</span>" +
                        "</span>" +
                        "<span class='product-title'>" + o.name + "</span>" +
                        "<span><b>SKU:</b> " + o.sku + "</span>";
                price = o.price.split('.', 2);
                if(o.quantity > 0){
                    
                    toAppend += "<span class='price'><em><span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>$</span>" 
                    + price[0] 
                    + "<span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>" 
                    + price[1] + "</span>"         
                    + "</em></span>";
                }else{
                    toAppend += "<span class='price sold-out'><em>OUT OF STOCK</em></span>"
                }
                //        "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                toAppend += "</a>" +
                    "<div id='prod-" + o.id + "' class='white-popup mfp-hide clearfix'>" +
                        "<div class='product-images clearfix'>" +
                            "<span class='main-image'>" +
                                "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                //               "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                            "</span>" +
                        "</div>" +
                        "<div class='product-details'>" +
                        "<h1>" + o.name + "</h1>" +
                        "<b>Item SKU:</b> " + o.sku +
                        "<div class='product-price-wrap'>" +
                            "<span class='price'><em><span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>$</span>" 
                    + price[0] 
                    + "<span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>" 
                    + price[1] + "</span>"         
                    + "</em></span>" +
                        "</div>";
                if(o.quantity > 0){
                    toAppend += "<form action='/cart/add' onSubmit='return checkProductQty(" + o.id + ", " + o.variant_id + ", \"" + o.name + "\"," +  o.quantity + ");' method='post' class='cartableProduct single-var'>" +
                                "<div class='product-variants'>" +
                                    "<fieldset>" +
                                        "<input type='hidden' name='id' value='" + o.variant_id + "'>" +
                                    "</fieldset>" +
                                    "<div class='var-msg'></div>" +
                                "</div>  " +
                                "<div class='quick-actions clearfix'>" +
                                    "<p class='qty-field'>" +
                                        "<label for='product-quantity-" + o.id + "'>Qty:</label>" +
                                        "<input type='number' id='product-quantity-" + o.id + "' name='quantity' value='1' min='1'>" +
                                    "</p>" +
                                    "<div id='inventory' style='float: left; font-weight: bold; font-size: 1em; text-align: center; padding-top: 15px;'>" + o.quantity + " in stock</div>" +
                                    "<input type='submit' class='add-to-cart' class='btn' name='add' value='Add to cart'>" +
                                 "</div>" +
                            "</form>";
                }else{
                    toAppend += "<p style='color: #F70023'><strong>Sorry, this product is temporarily out of stock.</strong></p>";
                }
                toAppend += "<div class='product-description rte'>" + o.description + "</div>" +
                                "<a href='" + o.link + "'><strong>» View full product details</strong></a>" +
                                "<br> <br>" +
                            "</div>" +
                    "</div>" +
                "</li>";
            }
        }
    });
    if(select_id != "product"){
        $("#" + select_id).empty().append(toAppend);
        //$("#" + select_id).chosen();
    }
    else{    
        toAppend += "</ul></div></div>";
        $("#" + select_id).html(toAppend);
        $("#productHeader").html("Your Results:");
        bindQuickView();
        impressionsView("automotive", data, "");
    }
    
}

function setDataTable(data, location){
    toAppend = '';
    toAppend += "<div class='table-cells'><table>";
    toAppend += "<tr><th colspan='2'>" + location.toUpperCase() + '</th></tr>';
    $.each(data,function(i,o){
        console.log(o.class);
        toAppend += "<tr><td width='40px' height='40px' class='auto_image " + o.class + "'></td><td>";
        parameters = o.id + ',\"' + o.value + '\",' + o.location_id + ',\"' + o.location_value + '\"';
        //alert(parameters);
        toAppend += '<a class="link" onclick=\'setValue(' + parameters + ')\'>' + o.location_value + '</a>';
        if(o.set_message){
            toAppend += " (Check Owner's Manual for correct bulb)";
        }
        toAppend += "</td></tr>";
    });
    toAppend += "</table></div>";
    $("#" + location).empty().append(toAppend);
}

function setValue(id, value, location_id, location_value){
    $("#main_location_id").val(id);
    $("#main_location_value").val(value);
    $("#location_id").val(location_id);
    $("#location_value").val(location_value);
    valueChanged("getproduct", 5);
}

function valueChanged(action, num){
    var sendrequest = false;
    var queryParameters = {}, queryString = location.search.substring(1), re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
        if(decodeURIComponent(m[1]) != "ansicode")
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    queryParameters['year'] = "";
    queryParameters['make'] = "";
    queryParameters['model'] = "";
    queryParameters['main_location'] = "";
    queryParameters['location'] = "";

    if($("#year").val() && num >= 1)
        queryParameters['year'] = $("#year option:selected").text();

    if($("#make").val() && num >= 2)
        queryParameters['make'] = $("#make option:selected").text();

    if($("#model").val() && num >= 3)
        queryParameters['model'] = $("#model option:selected").text();

    if($("#main_location_value").val() && num >= 4){
        queryParameters['main_location'] = $("#main_location_value").val();
        queryParameters['main_location_id'] = $("#main_location_id").val();
    }

    if($("#location_value").val() && num >= 5){
        queryParameters['location'] = $("#location_value").val();
        queryParameters['location_id'] = $("#location_id").val();
    }

    queryParameters['action'] = action;
    if(queryParameters['action'] == "")
        queryParameters['action'] = "getyear";

    var year = $("#year").val();
    var make = $("#make").val();
    var model = $("#model").val();
    var main_location = $("#main_location_value").val();
    var loc = $("#location_value").val();

    if(action == "getyear")
        sendrequest = true;
    else if(action == "getmake" && year)
        sendrequest = true;
    else if(action == "getmodel" && year && make)
        sendrequest = true;
    else if(action == "getmainlocation" && year && make && model)
        sendrequest = true;
    else if(action == "getlocation" && year && make && model && main_location)
        sendrequest = true;
    else if(action == "getproduct" && year && make && model && main_location && loc)
        sendrequest = true;          

    if(sendrequest){
        location.search = $.param(queryParameters); // Causes page to reload
    }
}

function textValueChanged(action){
    if($('#ansicode').val() != 'Search By Ansicode'){
    var sendrequest = false;
    var queryParameters = {}, queryString = location.search.substring(1), re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
        if(decodeURIComponent(m[1]) == "ansicode")
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    if(action == "getproductbyansi" && $('#ansicode').val()){
        queryParameters['ansicode'] = $('#ansicode').val();
        queryParameters['action'] = "getproductbyansi";
        sendrequest = true;
    }
    if(sendrequest)
        location.search = $.param(queryParameters);
    }
}

function getID(field, value){
    var automotive_data = JSON.parse(localStorage.getItem("automotive_data"));
    $.each(automotive_data[field],function(i,o){
        if(o.value == value){
                val = o.id;    
        }
    });
    return val;
}

function pageReady(){
    var year = getParameterByName("year");
    var make = getParameterByName("make");
    var model = getParameterByName("model");
    var main_location = getParameterByName("main_location");
    var location = getParameterByName("location");
    var action = getParameterByName("action");
    
    var year_id = "", make_id = "", model_id = "", main_location_id = "", location_id = "";
    
    if(localStorage.automotive_data){
        if(year)
            year_id = getID("year", year);
        if(make)
            make_id = getID("make", make);
        if(model)
            model_id = getID("model", model);
        if(main_location)
            main_location_id = getParameterByName("main_location_id");
        if(location)
            location_id = getParameterByName("location_id");
    }
    if(action == "")
        action = "getyear";
   
    $.ajax({
     type: "POST",
     url: url,
     //async: false,
     data: {year: year, year_id: year_id,
            make: make, make_id: make_id,
            model: model, model_id: model_id,
            main_location: main_location, main_location_id: main_location_id,
            location: location, location_id: location_id,
            action: action},
     dataType: "json",
     success: function(data){

        if(typeof(Storage) !== "undefined") {
            var automotive_data = JSON.parse(localStorage.getItem("automotive_data"));
            if(automotive_data){
                if(action == "getmake"){
                    automotive_data['make'] = [];
                    automotive_data['model'] = [];
                    automotive_data['main_location'] = [];
                    automotive_data['location'] = [];
                    automotive_data['product'] = [];
                }
                if(action == "getmodel"){
                    automotive_data['model'] = [];
                    automotive_data['main_location'] = [];
                    automotive_data['location'] = [];
                    automotive_data['product'] = [];
                }
                if(action == "getmainlocation"){
                    automotive_data['main_location'] = [];
                    automotive_data['location'] = [];
                    automotive_data['product'] = [];
                }
                if(action == "getproduct"){
                    automotive_data['product'] = [];
                }
                merged_data = $.extend({}, automotive_data, data);
                localStorage.setItem("automotive_data", JSON.stringify(merged_data));
            }
            else{
                localStorage.setItem("automotive_data", JSON.stringify(data));
            }
            
        } else {
            // Sorry! No Web Storage support..
        }
        automotive_data = JSON.parse(localStorage.getItem("automotive_data"));
        if(automotive_data['year'].length > 1){
          var width = "77%";
            setData(automotive_data['year'], "year");
            $("#year").width(width);
            $("#year").chosen();
            if(action == "getmake"){
                if(automotive_data['make'].length){
                    setData(automotive_data['make'], "make");
                    $("#make").prop("disabled", false);
                    $("#make").width(width);
                    $("#make").chosen();
                }else{
                    $("#results").show();
                    toAppend = "<b>No Make available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }else if(action == "getmodel"){
                setData(automotive_data['make'], "make");
                $("#make").prop("disabled", false);
                $("#make").width(width);
                $("#make").chosen();
                if(automotive_data['model'].length){
                    setData(automotive_data['model'], "model");
                    $("#model").prop("disabled", false);
                    $("#model").width(width);
                    $("#model").chosen();
                }else{
                    $("#results").show();
                    toAppend = "<b>No Model available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }else if(action == "getmainlocation"){
                $("#locationTableHeader").show();
                setData(automotive_data['make'], "make");
                $("#make").prop("disabled", false);
                $("#make").width(width);
                $("#make").chosen();
                setData(automotive_data['model'], "model");
                $("#model").prop("disabled", false);
                $("#model").width(width);
                $("#model").chosen();
                if(automotive_data['interior_location'].length){
                    setDataTable(automotive_data['interior_location'], "interior");
                }
                if(automotive_data['exterior_location'].length){
                    setDataTable(automotive_data['exterior_location'], "exterior");
                }
                if(!automotive_data['interior_location'].length && !automotive_data['exterior_location'].length)
                {
                    $("#results").show();
                    toAppend = "<b>No Location available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            } /*else if(action == "getlocation"){
                setData(automotive_data['make'], "make");
                $("#make").prop("disabled", false);
                $("#make").width(width);
                $("#make").chosen();
                setData(automotive_data['model'], "model");
                $("#model").prop("disabled", false);
                $("#model").width(width);
                $("#model").chosen();
                setData(automotive_data['main_location'], "main_location");
                $("#main_location").prop("disabled", false);
                $("#main_location").css("display", "block");
                $("#main_location").width(width);
                $("#main_location").chosen();
                if(automotive_data['location'].length){
                    setData(automotive_data['location'], "location");
                    $("#location").prop("disabled", false);
                    $("#location").css("display", "block");
                    $("#location").width(width);
                    $("#location").chosen();
                }else{
                    toAppend = "<b>No Location available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }*/else if(action == "getproduct"){
                $("#locationTableHeader").show();
                setData(automotive_data['make'], "make");
                $("#make").prop("disabled", false);
                $("#make").width(width);
                $("#make").chosen();
                setData(automotive_data['model'], "model");
                $("#model").prop("disabled", false);
                $("#model").width(width);
                $("#model").chosen();
                if(automotive_data['interior_location'].length){
                    setDataTable(automotive_data['interior_location'], "interior");
                }
                if(automotive_data['exterior_location'].length){
                    setDataTable(automotive_data['exterior_location'], "exterior");
                }
                $("#locationTable").hide();
                $("#selected_location_value").html(location);
                $("#selected_location").show();
                $("#results").show();
                if(automotive_data['product'].length > 1){
                    setData(automotive_data['product'], 'product');
                }else{
                    toAppend = "<b>No Product available for the above selection.</b>";
                    $("#message").html(toAppend);
                }
            }
        }
    },
      error: function (jqXHR, exception) {
    console.log(jqXHR);
    // error handling logic here..
}
});
}
   
function pageReadyAnsi(){
    var ansicode = getParameterByName("ansicode");
    var action = getParameterByName("action");
    
    $.ajax({
     type: "POST",
     url: url,
     async: false,
     data: {ansicode: ansicode,
            action: action},
     dataType: "json",
     success: function(data){
        var width = "77%";
         $('#ansicode').val(ansicode);
         if(data['year']){
            setData(data['year'], "year");
            $("#year").width(width);
            $("#year").chosen();
         }
         $("#results").show();
         if(data['product']){
            //$("#automotiveOptions1").show();
            setData(data['product'], 'product');
            
        }else{
            toAppend = "<b>No Product available for the above selection.</b>";
            $("#message").html(toAppend);
        }
     },
     error: function(){
        $("#results").show();
         $('#ansicode').val(ansicode);
         toAppend = "<b>No Product available for the above selection.</b>";
         $("#message").html(toAppend);
     } 
 });
}